import React from 'react';
import { FaTable } from 'react-icons/fa';
import { Card, SectionTitle, CountPill, EmptyState } from './Primitives';

/**
 * Deduplicazione visuale delle tabelle collegate alle macrofunzioni selezionate.
 * Ogni tabella distinta è mostrata una sola volta con il numero di macrofunzioni
 * che vi puntano.
 */
export default function TablesDedup({ tables }) {
  return (
    <Card className="p-5">
      <SectionTitle
        icon={FaTable}
        title="Tabelle collegate"
        subtitle="Tabelle distinte derivate dalla selezione"
        action={tables.length > 0 && <CountPill>{tables.length} distinte</CountPill>}
      />
      <div className="mt-4">
        {tables.length === 0 ? (
          <EmptyState
            icon={FaTable}
            title="Nessuna tabella"
            hint="Seleziona una o più macrofunzioni per vedere le tabelle collegate."
          />
        ) : (
          <ul className="flex flex-wrap gap-2">
            {tables.map((t) => (
              <li
                key={t.tableId}
                className="flex items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-900/50"
              >
                <FaTable className="text-primary" size={13} />
                <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
                  {t.tableName}
                </span>
                <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary dark:bg-primary/20">
                  {t.macroFunctionIds.length}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
}
